import { Authenticator } from '@aws-amplify/ui-react';
import { Box, Typography } from '@mui/material';

// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';

export function Authenticate(props) {
  const components = {
    SignIn: {
      Header() {
        return (
          <Typography
            variant="h5"
            sx={{ fontSize: 18, fontWeight: 'normal', pl: 4, pt: 4 }}
          >
            Sign in to your account
          </Typography>
        );
      },
    },
  };

  return (
    <Box
      sx={{
        height: '100%',
        overflowY: 'auto',
        lineHeight: 'normal',

        '[data-amplify-authenticator]': {
          mt: 4,

          '& [data-amplify-router]': {
            border: 'none',
            borderRadius: '6px',
            boxShadow: '1px 1px 4px #00000026',
          },

          '& .amplify-heading': {
            fontSize: 18,
            fontWeight: 'normal',
          },

          '& .amplify-heading--3': {
            mb: 2,
          },

          '& .amplify-field__show-password': {
            display: 'none',
          },

          '& .amplify-button--primary': {
            backgroundColor: '#333',
          },

          '& .amplify-button--link': {
            color: '#333',

            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.05)',
            },
          },
        },
      }}
    >
      <Authenticator hideSignUp components={components}>
        {props.children}
      </Authenticator>
    </Box>
  );
}
